// Dependecies
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Accordion } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Moment from 'react-moment';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Pagination } from 'antd';
import 'antd/dist/antd.css';
import { withTranslation } from 'react-i18next';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

// Component
import Template from '../../components/Template';
import PopUp from '../../components/Modal';
import Spinner from '../../components/Spinner';
import RenderTooltip from '../../components/RenderTooltip';
import ModalImage from '../../components/ModalImage';
import Successfully from '../../components/Successfully';
import FixedJobRequest from '../../components/JobRequest';

// Hooks
import useQualifyService from '../../hooks/useQualifyService';
import useNotificationRead from '../../hooks/useNotificationRead';

// Images
import arrowDown from '../../../sass/images/icons/arrow-down.svg';
import arrowUp from '../../../sass/images/icons/arrow-up.svg';
import search from '../../../sass/images/icons/search.svg';
import check from '../../../sass/images/icons/check.svg';
import qualifyServices from '../../../sass/images/company/qualify-service.svg';
import img from '../../../sass/images/icons/right-check.svg';
import eye from '../../../sass/images/ver-ocultar.svg';
import close from '../../../sass/images/icons/cerrar.svg';

// Utils
import { urlPublicS3 } from '../../helpers';

function QualityService(props) {
  const [activeKey, setActiveKey] = useState(0);
  const { newMaintenancesCompany } = useNotificationRead();
  const {
    qualifyServiceBool,
    qualifyService,
    openModalStarsInvert,
    closeModal,
    idService,
    star,
    setStar,
    CustomToggle,
    searchLicensePlate,
    imagen,
    valuePlate,
    setValuePlate,
    aproveService,
    onSubmitStartCompany,
    reload,
    urlImageService,
    openModalImage,
    successfully,
    setSuccessfully,
  } = useQualifyService();
  const { t } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(5);
  const [cardPerPage] = useState(5);

  // change page
  const handleChange = (page) => {
    setCurrentPage(page);
    setMinIndex((page - 1) * cardPerPage);
    setMaxIndex(page * cardPerPage);
  };
  const hourChange = (time) => moment(time, 'hh:mm a');

  return (
    <Template
      type={4}
      newMaintenances={newMaintenancesCompany}
      classNameContainer="maintenance"
      className="container_menu maintenance"
    >
      <>
        {openModalStarsInvert ? (
          <PopUp
            open={openModalStarsInvert}
            close={closeModal}
            icon=""
            title={t('maintenanceCompany:title-open-modal-star')}
            go={t('maintenanceCompany:go-modal-star')}
            modalDesign
            classNameContent="modal-confirm-star"
            showQuestionStarInvert
            idService={idService}
            onSubmitSatisfactionQuestionnaire={onSubmitStartCompany}
            star={star}
            setStar={setStar}
          />
        ) : (
          ''
        )}
        {openModalImage ? (
          <ModalImage isBlocked={openModalImage} close={closeModal} urlImage={urlImageService} />
        ) : (
          ''
        )}

        {!reload ? (
          <Spinner text={t('alert:reload')}> </Spinner>
        ) : (
          <>
            {successfully ? (
              <Successfully
                img={img}
                t={t}
                setAlert={setSuccessfully}
                txt1={t('qualityService:successfully')}
              />
            ) : (
              <>
                {qualifyServiceBool === 0 ? (
                  <>
                    <FixedJobRequest />
                    <div className="content_dynamic history">
                      <Row className="content_history">
                        <div className="header-content">
                          <div className="info-tittle">
                            <h1 className="title-maintenances">{t('qualityService:title')}</h1>
                          </div>
                        </div>
                        <div className="not-services">
                          <img
                            src={qualifyServices}
                            className="img-not-maintenances"
                            alt={t('alt:not_mantenice')}
                          />
                          <h4 className="center">{t('qualityService:first-txt')}</h4>
                        </div>
                      </Row>
                    </div>
                  </>
                ) : (
                  <div className="content_dynamic history company-block">
                    <Row className="content_maintenace">
                      <div className="header-content">
                        <div className="info-tittle">
                          <h1 className="title-maintenances">{t('qualityService:title')}</h1>
                          <h4>{t('qualityService:description-2')}</h4>
                          <p>{t('qualityService:description-1')}</p>
                        </div>
                      </div>
                      <div className="convention-services qualify">
                        <div className="modal-display company-content row-states">
                          <input
                            className="input_search form-control"
                            placeholder={t('search-plate')}
                            id="search-plate"
                            name="search-plate"
                            type="text"
                            value={valuePlate || ''}
                            onChange={(e) => {
                              setValuePlate(e.target.value.toUpperCase());
                            }}
                          />
                          <button
                            type="button"
                            onClick={() =>
                              imagen === check
                                ? searchLicensePlate(valuePlate, close)
                                : searchLicensePlate('', check)
                            }
                          >
                            <img src={valuePlate ? imagen : search} alt={t('alt:search')} />
                          </button>
                        </div>
                      </div>
                    </Row>
                    <Row className="no-gutters">
                      {qualifyService.length <= 0 ? (
                        <div className="content_not_mantenaice company">
                          <img
                            src={qualifyServices}
                            className="img-not-maintenances small"
                            alt={t('alt:not_mantenice')}
                          />
                          <h4>
                            {t('alert3')} {valuePlate}
                          </h4>
                          <Button
                            className="btn-orange"
                            style={{ width: '250px', padding: '0px' }}
                            variant="light"
                            onClick={() => searchLicensePlate('', check)}
                          >
                            {t('buttom-alert2')}
                          </Button>
                        </div>
                      ) : (
                        <>
                          <Accordion className="col-12">
                            {qualifyService.map(
                              (maintenance, index) =>
                                index >= minIndex &&
                                index < maxIndex && (
                                  <>
                                    {maintenance.company_observations === null ? (
                                      <Card className="main-card" key={maintenance.id} PageItem>
                                        <div
                                          className={`borde-status status-${maintenance.id_status}`}
                                        />
                                        <Card.Header
                                          className={`card-maintenances ${
                                            activeKey === maintenance.id
                                              ? 'head-show'
                                              : 'head-hidden'
                                          }`}
                                        >
                                          <Row>
                                            <Col
                                              className="col-head"
                                              xs={6}
                                              sm={3}
                                              md={3}
                                              lg={3}
                                              xl={4}
                                            >
                                              <div className="arrow-card">
                                                <p className="title-2">{t('license-plate')}</p>
                                                <p className="txt">
                                                  {maintenance.vehicle.licenseplate}
                                                  <OverlayTrigger
                                                    placement="top"
                                                    className="tooltip-info vehicle"
                                                    id="vehicle"
                                                    delay={{ show: 50, hide: 500 }}
                                                    overlay={(componentProps) =>
                                                      RenderTooltip({
                                                        ...componentProps,
                                                        text: `${t('brand')}`,
                                                        text2: `${t('model')}`,
                                                        text3: `${t('color')}`,
                                                        brand: maintenance.vehicle.brand.name,
                                                        model: maintenance.vehicle.model.name,
                                                        color: maintenance.vehicle.color,
                                                        id: 'tooltip-info-vehicle',
                                                        classtxt: 'tooltip-txt-info',
                                                      })
                                                    }
                                                  >
                                                    <img
                                                      className="info-maintenance-company"
                                                      src={eye}
                                                      alt={t('alt:tooltip')}
                                                    />
                                                  </OverlayTrigger>
                                                </p>
                                              </div>
                                            </Col>
                                            <Col
                                              className="col-head"
                                              xs={6}
                                              sm={3}
                                              md={3}
                                              lg={3}
                                              xl={4}
                                            >
                                              <CustomToggle
                                                as={Button}
                                                eventKey={maintenance.id}
                                                handleClick={() => {
                                                  if (activeKey === maintenance.id) {
                                                    setActiveKey(null);
                                                  } else {
                                                    setActiveKey(maintenance.id);
                                                  }
                                                }}
                                              >
                                                <p className="title-2">{t('date-hour-request')}</p>
                                                <p className="txt">
                                                  <Moment format="DD/MM/YYYY hh:mm a">
                                                    {maintenance.created_at}
                                                  </Moment>
                                                </p>
                                              </CustomToggle>
                                            </Col>
                                            <Col
                                              className="col-head"
                                              xs={6}
                                              sm={3}
                                              md={3}
                                              lg={3}
                                              xl={4}
                                            >
                                              <CustomToggle
                                                as={Button}
                                                eventKey={maintenance.id}
                                                handleClick={() => {
                                                  if (activeKey === maintenance.id) {
                                                    setActiveKey(null);
                                                  } else {
                                                    setActiveKey(maintenance.id);
                                                  }
                                                }}
                                              >
                                                <p className="title-2">
                                                  {t('maintenanceCompany:id-service')}
                                                </p>
                                                <p className="txt">{maintenance.id}</p>
                                              </CustomToggle>
                                            </Col>
                                            <Col className="toggle-matenaice">
                                              <Button
                                                className="btn-option aprobe company-button"
                                                onClick={() => aproveService(maintenance.id)}
                                              >
                                                {t('approve-service')}
                                              </Button>
                                            </Col>
                                            <div className="toggle-icon">
                                              <CustomToggle
                                                as={Button}
                                                eventKey={maintenance.id}
                                                handleClick={() => {
                                                  if (activeKey === maintenance.id) {
                                                    setActiveKey(null);
                                                  } else {
                                                    setActiveKey(maintenance.id);
                                                  }
                                                }}
                                              >
                                                {activeKey === maintenance.id ? (
                                                  <img
                                                    className="img-arrow-last"
                                                    src={arrowUp}
                                                    alt={t('alt:hidden_information')}
                                                  />
                                                ) : (
                                                  <img
                                                    className="img-arrow-last"
                                                    src={arrowDown}
                                                    alt={t('alt:show_information')}
                                                  />
                                                )}
                                              </CustomToggle>
                                            </div>
                                          </Row>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey={maintenance.id}>
                                          <Card.Body className="description-card">
                                            <div className="block-observations">
                                              <Row>
                                                <Col xs={12} md={12} className="col-collapse">
                                                  <h6 className="bold">
                                                    {t('maintenanceCompany:observations-block-1')}
                                                  </h6>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col xs={12} md={12} className="col-collapse">
                                                  <p className="second title-2">
                                                    {t('maintenanceCompany:name-workshop')}
                                                  </p>
                                                  <p className="txt">
                                                    {maintenance.garage_worshop
                                                      ? maintenance.garage_worshop.workshop
                                                      : ''}
                                                  </p>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col xs={12} md={12} className="col-collapse">
                                                  <p className="second title-2">
                                                    {t('maintenanceCompany:observations-mechanics')}
                                                  </p>
                                                  <p className="txt observations-mechanics">
                                                    {maintenance.mechanics_observations}
                                                  </p>
                                                </Col>
                                              </Row>
                                            </div>
                                            <div>
                                              <Row>
                                                <Col xs={12} md={12}>
                                                  <h6 className="bold">
                                                    {t('maintenanceCompany:observations')}
                                                  </h6>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col xs={12} md={3} className="col-collapse">
                                                  <p className="title-2">{t('name')}</p>
                                                  <p className="txt">
                                                    {`${maintenance.driver.name} ${maintenance.driver.last_name}`}
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={3} className="col-collapse">
                                                  <p className="title-2">
                                                    {t('maintenanceCompany:service-type')}
                                                  </p>
                                                  <p className="txt">
                                                    {maintenance.service_type.split(',')[0]}
                                                    {maintenance.service_type.split(',').length >
                                                    1 ? (
                                                      <OverlayTrigger
                                                        placement="top"
                                                        className="tooltip-info vehicle"
                                                        id="vehicle"
                                                        delay={{ show: 50, hide: 500 }}
                                                        overlay={(componentProps) =>
                                                          RenderTooltip({
                                                            ...componentProps,
                                                            items:
                                                              maintenance.service_type.split(','),
                                                            id: 'tooltip-type-services',
                                                            classtxt: 'tooltip-txt-info',
                                                          })
                                                        }
                                                      >
                                                        <img
                                                          className="info-maintenance-company"
                                                          src={eye}
                                                          alt={t('alt:tooltip')}
                                                        />
                                                      </OverlayTrigger>
                                                    ) : (
                                                      ''
                                                    )}
                                                  </p>
                                                </Col>
                                                <Col xs={6} md={3} className="col-collapse">
                                                  <p className="title-2">
                                                    {t('maintenance:date-hour-service')}
                                                  </p>
                                                  <p className="txt">
                                                    <Moment format="DD/MM/YYYY">
                                                      {maintenance.date_service}
                                                    </Moment>{' '}
                                                    <Moment
                                                      date={hourChange(maintenance.service_hours)}
                                                      format="hh:mm a"
                                                    />
                                                  </p>
                                                </Col>
                                                <Col xs={6} md={3} className="col-collapse">
                                                  <p className="second title-2">{t('image')}</p>
                                                  <p className="txt">
                                                    {maintenance.image ? (
                                                      <a
                                                        className="a-vehicle"
                                                        href={`${urlPublicS3()}/${
                                                          maintenance.image
                                                        }`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                      >
                                                        {t('maintenance:see-image')}
                                                      </a>
                                                    ) : (
                                                      t('without-image')
                                                    )}
                                                  </p>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col xs={12} md={12} className="col-collapse">
                                                  <p className="second title-2">
                                                    {t('maintenanceCompany:description-card')}
                                                  </p>
                                                  <p className="txt observations-mechanics">
                                                    {maintenance.description}
                                                  </p>
                                                </Col>
                                              </Row>
                                            </div>
                                          </Card.Body>
                                        </Accordion.Collapse>
                                        <div className="block-btn-opt">
                                          <Button
                                            className=""
                                            onClick={() => aproveService(maintenance.id)}
                                          >
                                            {t('approve-service')}
                                          </Button>
                                        </div>
                                      </Card>
                                    ) : (
                                      ''
                                    )}
                                  </>
                                )
                            )}
                          </Accordion>
                          <Pagination
                            className="col-12"
                            size="small"
                            defaultCurrent={1}
                            total={qualifyService.length}
                            defaultPageSize={cardPerPage}
                            current={currentPage}
                            onChange={handleChange}
                          />
                        </>
                      )}
                    </Row>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </>
    </Template>
  );
}

QualityService.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation([
  'maintenance',
  'maintenanceCompany',
  'qualityService',
  'alert',
  'routers',
])(QualityService);
